import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CheckCircle2Icon } from "lucide-react";
import { system } from "../data/salesCopy";
export function SystemOverview() {
  const reduce = useReducedMotion();
  const loop = [...system.tags, ...system.tags];
  return <section className="overflow-hidden bg-chalk-dark py-9 text-white md:py-16" data-id="element-270" data-mp="1hnujrxmt8l3x">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 lg:grid-cols-2 lg:gap-12" data-id="element-271" data-mp="1hpx7uc4ek460">
        <div className="min-w-0" data-id="element-272" data-mp="u02uzuk32flr">
          <p className="text-xs font-bold tracking-wide text-pencil md:text-sm" data-id="element-273" data-mp="pwwqarcmcwhe">{system.eyebrow}</p>
          <p className="mt-2 font-display text-xl font-bold leading-snug md:text-3xl" data-id="element-274" data-mp="13wpcqah44qjk">{system.summary}</p>
          <dl className="mt-4 flex gap-8 md:mt-8 md:gap-10" data-id="element-275" data-mp="ywjq58pp9u8c">
            {system.stats.map(s => <div key={s.label} data-id="element-276" data-mp="2fajr8n0a7px6">
                <dt className="sr-only" data-id="element-277" data-mp="2f9rwtfif7y8h">{s.label}</dt>
                <dd className="font-display text-3xl font-extrabold text-pencil md:text-4xl" data-id="element-278" data-mp="2acrmutigabc3">{s.value}</dd>
                <dd className="text-xs text-white/70 md:text-sm" data-id="element-279" data-mp="2375op720aeyk">{s.label}</dd>
              </div>)}
          </dl>

          <div className="relative -mx-5 mt-5 overflow-hidden md:mx-0 md:mt-8" aria-label="Temas incluidos" data-id="element-280" data-mp="2845z1u5w23vh">
            <motion.ul className="flex w-max gap-2" animate={reduce ? undefined : {
            x: ["0%", "-50%"]
          }} transition={{
            duration: 30,
            ease: "linear",
            repeat: Infinity
          }} data-id="element-281" data-mp="2d5bptmfznh2d">
              {loop.map((t, i) => <li key={`${t}-${i}`} aria-hidden={i >= system.tags.length} className="shrink-0 rounded-full border border-white/20 px-3 py-1 text-xs md:text-sm" data-id="element-282" data-mp="1pe6cpf1fn2vr" data-mpi={i}>
                  {t}
                </li>)}
            </motion.ul>
          </div>
          <p className="mt-4 text-sm text-white/80 md:mt-6 md:text-base" data-id="element-283" data-mp="1z6lv2dgn5th6">{system.note}</p>
        </div>

        <div className="rounded-2xl bg-white/5 p-4 md:rounded-3xl md:p-7" data-id="element-284" data-mp="16ohv0nmldiyc">
          <h3 className="text-sm font-bold md:text-base" data-id="element-285" data-mp="16mn5sx4af4og">{system.areasTitle}</h3>
          <ul className="mt-3 grid grid-cols-2 gap-x-3 gap-y-2 md:mt-5 md:gap-3" data-id="element-286" data-mp="ym7husvlxg6p">
            {system.areas.map(a => <li key={a} className="flex items-center gap-2 text-[13px] md:text-base" data-id="element-287" data-mp="tmmhce0sgzrv">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-pencil md:h-5 md:w-5" aria-hidden="true" data-id="element-288" data-mp="18ctq220zv4fd" />
                <span data-id="element-289" data-mp="13glf70ttxxe0">{a}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}